








































































































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import RadioList from '@front-app/components/inputs/RadioList.vue';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import { Routes } from '@front-app/constants/routes';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import ListAdminMembers from '@front-app/modules/groupMember/components/ListAdminMembers.vue';
import ListNonAdminMembers from '@front-app/modules/groupMember/components/ListNonAdminMembers.vue';
import { useFilterMemberList, GroupMemberListRole } from '@front-app/modules/groupMember/hooks/useFilterMemberList';
import { MemberSort, useSortMemberRadio } from '@front-app/modules/groupMember/hooks/useSortMemberRadio';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { useGroupMembersStore } from '@front-app/store/singletons/GroupMembers';

const PAGE_SIZE = 20;

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		FontAwesomeIcon,
		ListAdminMembers,
		ListNonAdminMembers,
		RadioList,
		SelectBox,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		roleFilter: {
			type: String as PropType<GroupMemberListRole>,
			default: UserRole.MEMBER,
		},
		sortBy: {
			type: String as PropType<MemberSort>,
			default: MemberSort.ALPHABETICAL,
		},
	},
	setup(props, ctx) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const { hasMembersListAccess } = useAdminAccess(group);

		const {
			getNumMembersByRole,
		} = useGroupMembersStore(computed(() => props.groupId));

		// Filter/sort
		const {
			roleChoices,
			selectedRolesLabel,
		} = useFilterMemberList(ctx, computed(() => props.roleFilter), group);
		const getCountByRole = (role: UserRole) => getNumMembersByRole([role]);
		const goToRole = (role: UserRole) => {
			ctx.root.$router.push({ query: { ...ctx.root.$route.query, role } });
		};

		const {
			sortRadioState,
		} = useSortMemberRadio(ctx, computed(() => props.sortBy));
		const toSort = (sortBy: MemberSort) => ({ ...ctx.root.$route, query: { ...ctx.root.$route.query, sortBy } });
		// END Filter/sort

		// Add members
		const toInviteCampaign = computed(() => ({
			name: Routes.GROUP_ADMIN_INVITE_CAMPAIGN,
			params: { groupId: props.groupId },
		}));

		const toAddMembers = computed(() => ({
			name: Routes.GROUP_ADMIN_ADD_MEMBERS,
			params: { groupId: props.groupId },
		}));
		// END Add members

		return {
			hasMembersListAccess,
			BOTTOM_RIGHT: DropdownPosition.BOTTOM_RIGHT,
			// Sort/Filter
			UserRole,
			selectedRolesLabel,
			roleChoices,
			sortRadioState,
			goToRole,
			getCountByRole,
			toSort,
			// Add members
			toInviteCampaign,
			toAddMembers,
			// Util
			ButtonPalettes,
			PAGE_SIZE,
		};
	},
});
